import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlidesWide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="slides-wide"><path fillRule="evenodd" clipRule="evenodd" d="M2 5.75C2 4.7835 2.7835 4 3.75 4H16.25C17.2165 4 18 4.7835 18 5.75V8H20.25C21.2165 8 22 8.7835 22 9.75V18.25C22 19.2165 21.2165 20 20.25 20H7.75C6.7835 20 6 19.2165 6 18.25V16H3.75C2.7835 16 2 15.2165 2 14.25V5.75ZM6 9.75V14.5H3.75C3.61193 14.5 3.5 14.3881 3.5 14.25V5.75C3.5 5.61193 3.61193 5.5 3.75 5.5H16.25C16.3881 5.5 16.5 5.61193 16.5 5.75V8H7.75C6.7835 8 6 8.7835 6 9.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSlidesWide;
